import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class IndividualDetailService extends BaseApiService {
    getData(customerNumberId: number) {
        return this.get(`Customer/${customerNumberId}`);
    }

    public getDataByTransactionId(transactionNumber: string) {
        return this.get(`Customer/Individual/Transaction/${transactionNumber}`);
    }

    public getDriverCustomerByTransactionId(transactionNumber: string) {
        return this.get(`Driver/Credential/Individual/Transaction/${transactionNumber}`);
    }

    public isEditCustomer(customerNumberId: number) {
        return this.get(`Customer/Edit/${customerNumberId}`);
    }
}
